import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const ChangeData = () => {
    
    const sections = [
        { label: "Change Type", value: "ChangeType", items: [] },
        { label: "Raised Type", value: "RaisedType", items: [] },
        { label: "Current Status", value: "CurrentStatus", items: [] },
        { label: "Contract/Package", value: "ContractPackage", items: [] },
        { label: "Final Status", value: "FinalStatus", items: [] },
    ];

    return (
        <MasterData pageTitle="Change" sections={sections} />
    );
};

export default ChangeData;